import Button from 'antd/es/button/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input/Input';
import Select from 'antd/es/select';
import React from 'react';

import styles from 'src/app/components/CreateRelation/CreateRelation.module.scss';

const { Option } = Select;

const CreateRelation = () => {
  const [form] = Form.useForm();

  const onFinish = () => {};

  const onReset = () => {
    form.resetFields();
  };

  return (
    <Form className={styles.form} layout="vertical" form={form} name="control-hooks" onFinish={onFinish}>
      <Form.Item className={styles.firstFormItem} name="source" label="SOURCE" rules={[{ required: false }]}>
        <Select placeholder="Choose a source" allowClear>
          <Option value="source1">source 1</Option>
          <Option value="source2">source 2</Option>
          <Option value="source3">source 3</Option>
        </Select>
      </Form.Item>

      <Form.Item className={styles.formItem} name="player" label="PLAYER" rules={[{ required: false }]}>
        <Select placeholder="Choose a player" allowClear>
          <Option value="player1">player 1</Option>
          <Option value="player2">player 2</Option>
          <Option value="player3">player 3</Option>
        </Select>
      </Form.Item>
      <Form.Item className={styles.formItem} name="weight" label="WEIGHT" rules={[{ required: false }]}>
        <Input />
      </Form.Item>
      <Form.Item className={styles.formItem} name="delay" label="DELAY" rules={[{ required: false }]}>
        <Input />
      </Form.Item>
      <Form.Item className={styles.formItem} name="conflict" label="CONFLICT" rules={[{ required: false }]}>
        <Input />
      </Form.Item>
      <Form.Item className={styles.formItem} name="date" label="DATE" rules={[{ required: false }]}>
        <Input />
      </Form.Item>
      <Form.Item className={styles.lastFormItem}>
        <Button
          style={{
            marginRight: 10,
            background: 'gray',
            paddingLeft: 36,
            paddingRight: 36,
            fontSize: 10,
          }}
          type="primary"
          htmlType="submit"
        >
          SAVE
        </Button>
        <Button
          style={{
            paddingLeft: 36,
            paddingRight: 36,
            fontSize: 10,
          }}
          type="primary"
          htmlType="button"
          onClick={onReset}
        >
          CANCEL
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateRelation;

/* <div className={styles.containerDiv}>
      <div>
        <p className={styles.propertyTag}>WEIGHT</p>
        <input className={styles.propertyInput} placeholder="Weight" onChange={getProperty} />
      </div>
      <div>
        <p className={styles.propertyTag}>DELAY</p>
        <input className={styles.propertyInput} placeholder="Delay" onChange={getProperty} />
      </div>
      <div>
        <p className={styles.propertyTag}>CONFLICT</p>
        <input className={styles.propertyInput} placeholder="Conflict" onChange={getProperty} />
      </div>
      <div>
        <p className={styles.propertyTag}>DATE</p>
        <input className={styles.propertyInput} placeholder="Date" onChange={getProperty} />
      </div>
      <div className={styles.buttonsGroup}>
        <Button style={leftSideButton} type="primary">
          SAVE
        </Button>
        <Button style={rightSideButton} type="primary">
          CANCEL
        </Button>
      </div>
    </div> */
